var _g, _path, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualityHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 120,
    viewBox: "0 0 110 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_472_9906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4975 107.956C50.4722 109.093 52.712 109.691 54.9921 109.691C57.2723 109.691 59.5122 109.093 61.4869 107.956L93.5054 89.522C95.4799 88.3849 97.1195 86.7495 98.2596 84.78C99.3996 82.8105 99.9998 80.5764 100 78.3023L100 41.3882C99.9998 39.1141 99.3996 36.88 98.2596 34.9105C97.1195 32.9411 95.4799 31.3056 93.5054 30.1685L61.4868 11.735C59.5122 10.5978 57.2723 9.99911 54.9921 9.99911C52.712 9.99911 50.4722 10.5978 48.4975 11.735L16.4947 30.1685C14.5202 31.3056 12.8806 32.9411 11.7405 34.9105C10.6005 36.88 10.0002 39.1141 9.99999 41.3883L10 78.3023C10.0002 80.5765 10.6005 82.8106 11.7405 84.78C12.8806 86.7495 14.5202 88.3849 16.4947 89.522L48.4975 107.956Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6508 40.0767C52.39 39.5405 50.0146 40.2475 48.415 41.9327L40.2394 50.5455C38.6329 52.238 38.053 54.6598 38.7186 56.8964L41.671 66.816L30.4945 77.3532C29.3398 78.4419 29.2327 80.2415 30.2501 81.4594L30.9917 82.3471C32.0285 83.5882 33.8624 83.7842 35.138 82.7902L47.7947 72.9278L58.3878 75.4404C60.6485 75.9766 63.0239 75.2696 64.6235 73.5845L72.7991 64.9716C74.4056 63.2791 74.9856 60.8573 74.3199 58.6207L70.9515 47.3031C70.2858 45.0665 68.476 43.3559 66.2054 42.8174L54.6508 40.0767ZM55.8452 47.8289C54.3294 47.4461 52.7256 47.9234 51.6657 49.0728L47.6336 53.4456C46.6141 54.5511 46.2523 56.1119 46.6812 57.5532L48.4797 63.596C48.9087 65.0374 50.0651 66.1463 51.5232 66.5145L57.2902 67.9707C58.8061 68.3535 60.4099 67.8762 61.4697 66.7268L65.5019 62.354C66.5213 61.2485 66.8832 59.6877 66.4542 58.2464L64.6557 52.2036C64.2267 50.7622 63.0703 49.6533 61.6122 49.2851L55.8452 47.8289Z",
    fill: "url(#paint0_linear_472_9906)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.1683 58.3068L87.3742 62.5201C87.3846 62.7442 87.3059 62.9634 87.1551 63.1303C87.0044 63.2972 86.7937 63.3983 86.569 63.4116L84.2972 63.5218C84.1085 64.339 83.8252 65.1318 83.4531 65.8843L85.1435 67.4056C85.2264 67.48 85.2935 67.57 85.3411 67.6706C85.3886 67.7711 85.4156 67.8801 85.4204 67.9913C85.4253 68.1024 85.4078 68.2135 85.3692 68.318C85.3305 68.4224 85.2715 68.5182 85.1954 68.5998L82.3458 71.7301C82.2719 71.8131 82.1824 71.8808 82.0822 71.9291C81.982 71.9775 81.8732 72.0056 81.7621 72.0118C81.6511 72.018 81.5399 72.0023 81.4351 71.9654C81.3303 71.9286 81.2339 71.8713 81.1515 71.7971L79.4736 70.2718C78.7596 70.7201 77.9944 71.0812 77.1942 71.3476L77.3119 73.6078C77.3222 73.8318 77.2435 74.0511 77.0928 74.218C76.942 74.3849 76.7313 74.486 76.5067 74.4993L72.2666 74.7186C72.1555 74.724 72.0446 74.7074 71.9401 74.6698C71.8356 74.6322 71.7397 74.5743 71.6579 74.4995C71.5761 74.4247 71.51 74.3345 71.4634 74.234C71.4168 74.1335 71.3908 74.0247 71.3866 73.914L71.2688 71.6539C70.4532 71.4663 69.6626 71.1845 68.913 70.8142L67.3827 72.5026C67.3079 72.5854 67.2174 72.6525 67.1164 72.7001C67.0154 72.7477 66.906 72.7748 66.7945 72.7799C66.683 72.785 66.5716 72.7679 66.4668 72.7297C66.3621 72.6914 66.2663 72.6327 66.1846 72.557L63.042 69.7407C62.9592 69.6664 62.8922 69.5763 62.8446 69.4757C62.7971 69.3752 62.7701 69.2661 62.7653 69.155C62.7605 69.0439 62.7778 68.9328 62.8164 68.8284C62.855 68.7239 62.9142 68.628 62.9903 68.5464L64.508 66.862C64.0662 66.148 63.706 65.3867 63.434 64.5925L61.1661 64.7152C60.9413 64.726 60.7215 64.648 60.5544 64.4981C60.3873 64.3483 60.2864 64.1386 60.2736 63.9147L60.0675 59.7015C60.0572 59.4775 60.136 59.2581 60.2868 59.0912C60.4375 58.9243 60.6481 58.8233 60.8728 58.81L63.1405 58.6873C63.3306 57.874 63.6153 57.0853 63.9886 56.3373L62.3108 54.812C62.2276 54.7385 62.16 54.6493 62.1117 54.5496C62.0634 54.4498 62.0356 54.3415 62.0296 54.2308C62.0236 54.1201 62.0396 54.0093 62.0768 53.9048C62.1141 53.8002 62.1717 53.7041 62.2464 53.6218L65.092 50.479C65.2449 50.315 65.4562 50.2173 65.6804 50.2071C65.9046 50.1969 66.1237 50.275 66.2902 50.4245L67.9806 51.9458C68.6891 51.4958 69.4489 51.1317 70.2437 50.8614L70.1384 48.5973C70.132 48.4873 70.1476 48.377 70.184 48.2729C70.2204 48.1687 70.277 48.0727 70.3506 47.9903C70.4242 47.9078 70.5133 47.8407 70.6129 47.7925C70.7125 47.7444 70.8207 47.7163 70.9311 47.7098L75.1712 47.4906C75.2822 47.4852 75.3932 47.5017 75.4977 47.5393C75.6021 47.5769 75.698 47.6348 75.7798 47.7096C75.8617 47.7844 75.9278 47.8746 75.9744 47.9751C76.0209 48.0756 76.047 48.1844 76.0511 48.2951L76.169 50.5552C76.9873 50.7452 77.7817 51.0255 78.5373 51.3909L80.059 49.719C80.1338 49.6353 80.2242 49.5672 80.3253 49.5184C80.4264 49.4695 80.5361 49.441 80.6482 49.4344C80.7602 49.4278 80.8725 49.4433 80.9785 49.4799C81.0844 49.5166 81.1821 49.5737 81.2658 49.648L84.3997 52.4809C84.5645 52.6311 84.6636 52.8398 84.6756 53.0623C84.6876 53.2848 84.6117 53.5033 84.4641 53.6711L82.9339 55.3595C83.3742 56.0694 83.7332 56.8265 84.0039 57.6166L86.2757 57.5064C86.3874 57.4993 86.4994 57.5145 86.605 57.551C86.7107 57.5876 86.808 57.6448 86.8911 57.7193C86.9742 57.7939 87.0415 57.8843 87.0891 57.9851C87.1367 58.086 87.1637 58.1954 87.1683 58.3068ZM77.4762 60.9095C77.4465 60.1678 77.1965 59.452 76.7578 58.8531C76.3191 58.2541 75.7115 57.7989 75.0121 57.5452C74.3127 57.2914 73.553 57.2506 72.8292 57.4279C72.1055 57.6052 71.4504 57.9926 70.9469 58.5409C70.4435 59.0893 70.1143 59.7739 70.0013 60.508C69.8884 61.2421 69.9967 61.9926 70.3123 62.6643C70.628 63.3361 71.1369 63.8987 71.7745 64.2811C72.4121 64.6634 73.1496 64.8481 73.8936 64.8118C74.8856 64.7634 75.8192 64.3259 76.4903 63.5948C77.1615 62.8637 77.5159 61.8985 77.4762 60.9095Z",
    fill: "url(#paint1_linear_472_9906)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_472_9906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4975 107.956C50.4722 109.093 52.712 109.691 54.9921 109.691C57.2723 109.691 59.5122 109.093 61.4869 107.956L93.5054 89.522C95.4799 88.3849 97.1195 86.7495 98.2596 84.78C99.3996 82.8105 99.9998 80.5765 100 78.3023L100 41.3883C99.9998 39.1141 99.3996 36.88 98.2596 34.9105C97.1195 32.9411 95.4799 31.3056 93.5054 30.1685L61.4868 11.735C59.5122 10.5978 57.2723 9.99911 54.9921 9.99911C52.712 9.99911 50.4722 10.5978 48.4975 11.735L16.4947 30.1685C14.5202 31.3056 12.8806 32.9411 11.7405 34.9105C10.6005 36.88 10.0002 39.1141 9.99999 41.3883L10 78.3023C10.0002 80.5765 10.6005 82.8106 11.7405 84.78C12.8806 86.7495 14.5202 88.3849 16.4947 89.522L48.4975 107.956Z",
    fill: "#2468FF",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_472_9906",
    x: 0,
    y: 0,
    width: 110,
    height: 119.691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_472_9906"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_472_9906",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_472_9906",
    x: 0,
    y: 0,
    width: 110,
    height: 119.691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_472_9906"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_472_9906",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_472_9906",
    x1: 18.2942,
    y1: 46.7483,
    x2: 69.5272,
    y2: 83.3849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#927FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_472_9906",
    x1: 48.3244,
    y1: 52.0901,
    x2: 107.788,
    y2: 80.7336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010305",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityHover);
export default __webpack_public_path__ + "static/media/quality_hover.3976744e4423bcf5dc758e39d30f8782.svg";
export { ForwardRef as ReactComponent };